import { ChartArea } from "../../../charts/chartArea";
import { ChartPanel } from "../../../charts/chartPanel";
import ResetNewsData from "../../../controls/resetNewsData";
import { NewsTypeAnalytics } from "./newsTypeAnalytics";
import { NewsUploadedAnalytics } from "./newsUploadedAnalytics";
import { useState } from "react";
import ResetData from "../../../controls/resetData";
import { CategorySelecterDropdown } from "../../../controls/categoryDropdown";

const _props = {
  onDataFetch: (data) => {
    return {};
  },
  dataListTemplate:'',
  setSourceName:()=>{},
  chartConfig:{}
};
export function NewsAnalyticsInfo(props = _props) {
  const leftChartConfig = [...props.chartConfig.charts.leftW].sort(
    (a, b) => a.sequence - b.sequence
  ).filter(obj => obj.active === true);
  const rightChartConfig = [...props.chartConfig.charts.rightW].sort(
    (a, b) => a.sequence - b.sequence
  ).filter(obj => obj.active === true);

  const [leftGraph, setLeftGraph] = useState(leftChartConfig[0]);
  const [rightGraph, setRightGraph] = useState(rightChartConfig[0]);

  const [leftReset, setLeftReset] = useState(false)
  const [rightReset, setRightReset] = useState(false)

  return (
    <div className="mt-2">
      <ChartPanel
        left={
          <ChartArea
            key={leftGraph.name}
            chartConfig={leftGraph}
            title={leftGraph.title}
            categorySwitch={
              <CategorySelecterDropdown
                setCategory={setLeftGraph}
                categoryOptions={leftChartConfig}
                selectedCategory={leftGraph}
              />
            }
            resetData={<ResetNewsData reset={leftReset} setReset={setLeftReset} setSourceName={props.setSourceName} />}
            renderWithPeriod={(period) => {
              return (
                <NewsUploadedAnalytics
                  period={period}
                  graphConfig={leftGraph}
                  dataListTemplate={props.dataListTemplate}
                  setSourceName={props.setSourceName}
                  setReset={setLeftReset}
                />
              );
            }}
          ></ChartArea>
        }
        
        right={
          <ChartArea
            key={rightGraph.name}
            title={rightGraph.title}
            categorySwitch={
              <CategorySelecterDropdown
                setCategory={setRightGraph}
                categoryOptions={rightChartConfig}
                selectedCategory={rightGraph}
              />
            }
            chartConfig={rightGraph}
            resetData={<ResetNewsData reset={rightReset} setReset={setRightReset} setSourceName={props.setSourceName} />}
            renderWithPeriod={(period) => {
              return (
                <NewsUploadedAnalytics
                  graphConfig={rightGraph}
                  period={period}
                  dataListTemplate={props.dataListTemplate}
                  setSourceName={props.setSourceName}
                  setReset={setRightReset}
                />
              );
            }}
          ></ChartArea>
        }
      ></ChartPanel>
    </div>
  );
}
